import { useEffect, useState } from 'react'

import { api, type User } from '../api'

// Экран входа и регистрации. Если суперадмин закрыл регистрацию,
// форма показывает только вход.
export function Auth({ onReady }: { onReady: (user: User) => void }) {
  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [registrationOpen, setRegistrationOpen] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    api.settings().then((s) => setRegistrationOpen(s.registration_open)).catch(() => undefined)
  }, [])

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const result =
        mode === 'login'
          ? await api.login(email, password)
          : await api.register(email, password, name)
      onReady(result.user)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось войти')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="auth stack">
      <div>
        <h1>PushMe</h1>
        <p className="muted">Кабинет сервиса push-уведомлений</p>
      </div>

      <div className="card">
        <div className="tabs">
          <button className={mode === 'login' ? 'active' : ''} onClick={() => setMode('login')}>
            Вход
          </button>
          {registrationOpen && (
            <button className={mode === 'register' ? 'active' : ''} onClick={() => setMode('register')}>
              Регистрация
            </button>
          )}
        </div>

        <form onSubmit={submit}>
          {mode === 'register' && (
            <label>
              Имя
              <input value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" />
            </label>
          )}
          <label>
            Email
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </label>
          <label>
            Пароль
            <input
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            />
          </label>

          {error && <div className="notice error">{error}</div>}

          <button className="primary" type="submit" disabled={busy}>
            {mode === 'login' ? 'Войти' : 'Создать аккаунт'}
          </button>
        </form>
      </div>

      {!registrationOpen && mode === 'login' && (
        <p className="muted">Регистрация закрыта администратором платформы.</p>
      )}
    </div>
  )
}
